import React, { FC, useCallback } from "react";

import { type Place } from "@xapp/components";

import { ConfirmProfileStep, ConfirmProfileStepProps } from "components/Onboarding/components/V3";
import { usePlaceDetails } from "components/Onboarding/utils/usePlaceDetails";

import { OnboardingProps } from "../../models";
import { getTemplateFromPlace } from "components/Onboarding/utils/getTemplateFromPlace";
import { getLogoFromWebsite } from "components/Onboarding/utils/getLogoFromWebsite";

export interface ConfirmProfileContainerProps extends Omit<ConfirmProfileStepProps, "onConfirm" | "loading" | "place"> {
    /**
     * Place ID to confirm
     */
    placeId?: string;
    /**
     * Props with place to confirm
     */
    onboarding: OnboardingProps;
    /**
     * The user has confirmed
     *
     * @param props
     */
    onConfirm(props: OnboardingProps): void;
}

export const ConfirmProfileContainer: FC<ConfirmProfileContainerProps> = (props) => {
    const { placeId, onboarding, onConfirm, ...rest } = props;

    const [place, loadingPlace] = usePlaceDetails(placeId);

    const handleConfirmPlace = useCallback(
        (place: Place) => {
            const copy = { ...onboarding };

            copy.place = place;
            copy.name = place.name;
            copy.website = place.website;

            // Attempt to get the logo from the website
            if (!copy.logo) {
                const logo = getLogoFromWebsite(place.website);
                copy.logo = logo;
            }

            const template = getTemplateFromPlace(place);

            copy.template = template;

            onConfirm(copy);
        },
        [onConfirm, onboarding]
    );

    return <ConfirmProfileStep {...rest} loading={loadingPlace} place={place} onConfirm={handleConfirmPlace} />;
};
